module.exports = __webpack_public_path__ + "static/media/certificateofconformityback.2011cd01.svg";